<template>
  <div id="filelist-modal">
    <!--   <close-button @click="$emit('close')" class="close-button"></close-button> -->

    <div class="dialog-header">
      <h1>Bestanden delen</h1>

      <button id="files-btn" @click="showFiles" type="button">
        {{ filesToSend.length }} bestand<span v-if="filesToSend.length != 1"
          >en</span
        >
      </button>

      <transition name="fade">
        <div
          id="file-menu"
          v-if="fileMenuOpen"
          v-click-outside:files-btn="showFiles"
        >
          <div class="wrapper">
            <ul>
              <li v-for="file in filesToSend" :key="file.fileName">
                {{ file.fileName }}
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
    <form name="shareFilesForm" @submit.prevent="sendFiles">
      <div class="dialog-content">
        <div class="mail">
          <label>Email naar</label>

          <input
            type="text"
            class="grey-field email-input"
            name="email"
            v-model="mail.to"
            @input="$v.mail.to.$touch()"
            :class="{ invalid: $v.mail.to.$invalid && $v.mail.to.$dirty }"
          />
        </div>

        <div class="">
          <label>Bericht</label>

          <textarea
            class="message grey-field"
            v-model="mail.message"
          ></textarea>
        </div>

        <div class="valid-text">
          <div>
            <span>Downloadlink is geldig t/m {{ validTo }}.</span>
          </div>
        </div>
      </div>
      <div class="footer">
        <button
          type="button"
          @click="$emit('close')"
          class="link-button secondary"
        >
          Annuleren
        </button>
        <button type="submit" class="link-button" :disabled="$v.mail.$invalid">
          Verzenden
        </button>
      </div>
    </form>
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="sendSuccess">
        <h2>Uw bestanden worden verzonden</h2>
        <p>
          U ontvangt van ons een bevestiging per email wanneer de bestanden
          verzonden zijn.
        </p>
      </div>
    </transition>
  </div>
</template>
<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ErrorMessage from '@/dialogs/ErrorMessage'

import { fileShare, shareUploads } from '@/api/api'
import add from 'date-fns/add'
import format from 'date-fns/format'

import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'
import Cookies from 'js-cookie'
import { UPLOAD_COOKIE } from '@/stores/store'

const customEmail = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*;{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/.test(
    value
  )
}

export default {
  name: 'fileTransfer',
  props: {
    files: {
      default: function () {
        return []
      },
      type: Array
    },
    shareUploads: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return { $v: useVuelidate() }
  },
  data() {
    return {
      duration: 14,
      mail: {
        // endDate : validTo(7)
      },
      fileMenuOpen: false,
      sendSuccess: false
    }
  },
  methods: {
    /* updateVal() {
      if (this.duration > 30) {
        this.duration = 30
      } else if (this.duration < 1) {
        this.duration = 1
      }
    }, */
    showFiles() {
      this.fileMenuOpen = !this.fileMenuOpen
    },
    sendFiles() {
      if (this.shareUploads) {
        shareUploads({
          sessionId: Cookies.get(UPLOAD_COOKIE),
          userId: this.rootStore.user.uid,
          from: {
            name: this.rootStore.user.name,
            address: this.rootStore.user.username
          },
          recipients: this.mail.to.replace(/\s+/g, '').split(';'),
          expiryDays: this.duration,
          message: this.mail.message || ''
        })
          .then((response) => {
            this.shareResponse(response)
          })
          .catch((error) => {
            this.shareResponse({ message: `Foutmelding: "${error}"` })
          })
      } else {
        const fileIds = this.files.map((file) => file.fileId)

        fileShare({
          emails: this.mail.to.replace(/\s+/g, '').split(';'),
          message: this.mail.message || '',
          password: false,
          endDate: format(add(new Date(), { days: this.duration }), 'yyyy-M-d'),
          fileIds: fileIds
        }).then((response) => {
          this.shareResponse(response)
        })
      }
    },
    shareResponse(response) {
      if (response === true || response.result === 'success') {
        this.sendSuccess = true

        setTimeout(() => {
          this.$emit('close')
        }, 4500)
      } else {
        this.$modal.show(
          ErrorMessage,
          {
            title: 'Probleem bij bestanden delen',
            text: response.message + '<br>Neem contact op met de helpdesk.'
          },
          {
            height: 250,
            width: 380,
            adaptive: true
          }
        )
      }
    }
  },
  computed: {
    ...mapStores(useFileListStore),
    theme() {
      return this.rootStore.theme
    },
    buttons() {
      return this.rootStore.buttons
    },
    validTo() {
      let date = new Date()
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
      date.setDate(date.getDate() + this.duration)
      return date.toLocaleDateString('nl-NL', options)
    },
    filesToSend() {
      if (this.files.length) {
        let files = this.files
        files.forEach((fl) => {
          fl.fileName = fl.name
        })
        return files
      } else {
        return this.fileListStore.fileList
      }
    }
  },
  validations: {
    mail: {
      to: {
        required,
        customEmail
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#filelist-modal {
  padding: 15px;
}

#files-btn {
  position: absolute;
  right: 40px;
  font-size: 12px;
  background: var(--main-color);
  color: white;
  padding: 5px 10px;
  border-radius: 30px;
  top: 38px;
  font-weight: 400;
}

.email-input {
  max-width: 340px;
  width: 100%;
  margin-right: 0;
  margin-left: 5px;
}

label {
  width: 70px;
  font-weight: 300;
}

.mail {
  padding-bottom: 10px;
}

form {
  div {
    line-height: 34px;
  }
}

.days {
  text-align: center;
  font-weight: 400;
  margin: 0 0 0 4px;
  width: 45px;
}

.message {
  width: 100%;
  max-width: 340px;
  height: 200px;
  padding: 0;
  margin-left: 5px;
  padding: 10px;
}

.valid-text {
  text-align: right;
}

#file-menu {
  top: 70px;
  position: absolute;
  width: 85%;
  right: 7.5%;

  .wrapper {
    background-color: white;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 5px;
    overflow: hidden;
  }

  li {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 10px 35px 10px 20px;
    position: relative;

    &:first-child {
      padding-top: 20px;
    }

    &:last-child {
      padding-bottom: 20px;
    }
  }

  .remove-file {
    width: 10px;
    height: 10px;
    display: inline-block;
    height: 10px;
    position: absolute;
    right: 20px;
    margin-top: 4px;
  }
}

.footer {
  text-align: right;
  padding: 0 25px 15px;

  button {
    margin-left: 5px;
  }
}

.overlay-message {
  h2 {
    font-weight: 500;
    color: var(--sub-color);
    font-size: 15px;
  }
}
</style>
